import { useCurrentStateAndParams } from "@uirouter/react";

import { SI_SEARCH_ROUTES } from "app/common/constants/ad-intelligence-routes";
import { ROUTES } from "single-spa/react-app/config/solutions25/adIntelligence/searchAdvertising/searchAdvertisingConstants";

export interface IMonitorKeywordsNavigationTargets {
    monitorKeywordsState: string;
    monitorKeywordsHomeState: string;
    keywordOverviewState: string | undefined;
    serpPlayersState: string;
    trafficAnalysisState: string;
    keywordAdsState: string;
    keywordGeneratorState: string;
}

const keywordResearchNavigationTargets: IMonitorKeywordsNavigationTargets = {
    monitorKeywordsState: "digitalsuite_monitorkeywords",
    monitorKeywordsHomeState: "digitalsuite_monitorkeywords_home",
    keywordOverviewState: "organicsearch_keywordAnalysis_overview_2",
    serpPlayersState: "organicsearch_keywordAnalysis_2",
    trafficAnalysisState: "organicsearch_trafficAnalysis_2",
    keywordAdsState: "paidsearch_keywordAnalysis_serp_ads",
    keywordGeneratorState: "digitalsuite_findkeywords_keywordGeneratorTool",
};

const searchAdvertisingNavigationTargets: IMonitorKeywordsNavigationTargets = {
    monitorKeywordsState: ROUTES.monitorKeywords,
    monitorKeywordsHomeState: ROUTES.monitorKeywordsHome,
    keywordOverviewState: undefined,
    serpPlayersState: ROUTES.serpPlayers,
    trafficAnalysisState: ROUTES.keywordLandingPages,
    keywordAdsState: ROUTES.keywordAds,
    keywordGeneratorState: "digitalsuite_findkeywords_keywordGeneratorTool",
};

const monitorKeywordsNavigationTargetsMap: Record<string, IMonitorKeywordsNavigationTargets> = {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    digitalsuite_monitorkeywords_home: keywordResearchNavigationTargets,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    digitalsuite_monitorkeywords: keywordResearchNavigationTargets,
    [ROUTES.monitorKeywordsHome]: searchAdvertisingNavigationTargets,
    [ROUTES.monitorKeywords]: searchAdvertisingNavigationTargets,
    // Sales Intelligence mirror of Search Advertising (reuses the same in-page navigation targets).
    [SI_SEARCH_ROUTES.monitorKeywordsHome]: searchAdvertisingNavigationTargets,
    [SI_SEARCH_ROUTES.monitorKeywords]: searchAdvertisingNavigationTargets,
};

export const useMonitorKeywordsNavigationTargets = (): IMonitorKeywordsNavigationTargets => {
    const { state } = useCurrentStateAndParams();
    const navigationTargets = monitorKeywordsNavigationTargetsMap[state.name];

    if (!navigationTargets) {
        throw new Error(
            `No monitor keywords navigation targets configured for state: ${state.name}. ` +
                `Available states: ${Object.keys(monitorKeywordsNavigationTargetsMap).join(", ")}`,
        );
    }

    return navigationTargets;
};
